import * as Yup from "yup";

const ProposicaoAcontecimentosCreateSchema = Yup.object({
    descricao: Yup.string().required({ name: "descricao", err: "Campo com preenchimento obrigatório" }),
    date: Yup.date().required(),
    });


export default ProposicaoAcontecimentosCreateSchema;